<template>
<div>
  <Loading :loading="this.loading"></Loading>
  <div v-show="!loading" class="content-wrapper">
    <div class="container">
      <div class="mb16 card-select-item-register">
        <p class="">ご利用者様はカードを追加してください</p>
        <img src="/lib/images/cardSpecV3/refgister_card_button.png" alt="カードを登録" class="refgister-card-button" @click="goToRegisterCard">
      </div>

      <div class="white-panel">
        <div>
          <p class="fs16 text-left new-entry">新規ご入会</p>
        </div>

        <!-- オーパスカード -->
        <div class="card-select-item mb16" @click="goToCardSpec('opus')">
        <!-- <div class="card-select-item mb16"> -->
          <div class="card-title">
            <h3 class="fs16 card-title-text">コスモ・ザ・カード・オーパス</h3>
            <img src="/lib/images/cardSpecV3/right_arrow_button.png" alt="右矢印" class="right-arrow-button">
          </div>

          <div class="card-content">
            <img src="/lib/images/cardSpecV3/cosmo_the_card_opus.png" alt="オーパスカード" class="card-image">
            <ul class="card-features">
              <li>・入会金・年会費0円</li>
              <li>・Visa/Mastercard/JCBから選べます</li>
              <li>・「WAON POINT」がたまります</li>
            </ul>
          </div>
        </div>

        <!-- ハウスカード -->
        <div class="card-select-item">
          <div class="card-title">
            <h3 class="fs16 card-title-text">コスモ・ザ・カード・ハウス</h3>
          </div>

          <div class="card-content">
            <img src="/lib/images/cardSpecV3/cosmo_the_card_house.png" alt="ハウスカード" class="card-image">
            <ul class="card-features">
              <li>2026年9月30日(水)をもちまして、<br>新規お申し込みの受付は終了させていただきました。</li>
            </ul>
          </div>
          <span>※すでにカードをお持ちのお客さまは引き続きご利用いただけます。</span>
        </div>

        <div>
          <p class="fs11 mt16 notice-text">※こちらからお申込みいただくと、現在選択されている店舗からお知らせが届く場合がございます。</p>
        </div>

      </div>
    </div>
  </div>
</div>
</template>

<script>
import modal from '@/assets/v3/modal'
import Loading from '@/views/v3/Loading.vue'
import axios from 'axios'

export default {
  components: {
    Loading
  },
  data () {
    return {
      loading: true
    }
  },
  methods: {
    openErrorModal (message) {
      modal.alert(message)
    },
    goToRegisterCard () {
      const baseUrl = process.env.VUE_APP_INTEC_REGISTRATION_THE_CARD_URL
      const queryParams = new URLSearchParams({
        tsid: this.nativeData.tsid || '',
        ot: this.nativeData.otoken || '',
        frm: 'thecard'
      }).toString()

      // パラメータを含むURLとヘッダーのパラメータを作成
      const urlWithParams = `${baseUrl}?${queryParams}`
      const headerParams = `${this.nativeData.appVersion}/${this.nativeData.platform}/${this.nativeData.osVersion}`

      axios.get(urlWithParams, {
        headers: {
          'X-CLS-App-Version': headerParams
        }
      }).then(response => {
        // URLを取得
        const finalUrl = response.request.responseURL
        // ベースURLを構築
        const baseUrl = new URL(finalUrl).origin + new URL(finalUrl).pathname.substring(0, new URL(finalUrl).pathname.lastIndexOf('/') + 1)

        // HTMLのheadタグにbaseタグを追加
        let htmlContent = response.data
        htmlContent = htmlContent.replace('<head>', `<head><base href="${baseUrl}">`)

        // HTML内容をページに書き込む
        document.open()
        document.write(htmlContent)
        document.close()

        // ブラウザの履歴とURLを更新
        history.pushState({}, '', finalUrl)
      }).catch(error => {
        console.log('Navigation error:', error)
      })
    },
    goToCardSpec (cardType) {
      // クエリパラメータを設定
      const query = {
        tsid: this.nativeData.tsid,
        otoken: this.nativeData.otoken,
        x_cls_app_version: this.nativeData.appVersion,
        x_cls_os: this.nativeData.platform,
        x_cls_os_version: this.nativeData.osVersion
      }

      // カードタイプに応じて遷移先を振り分け
      if (cardType === 'opus') {
        // 遷移前にイベント送信
        this.nativeEVENTSet('CardNyukaiSokushinButton', 'CARD_POPUP', 'TAP')

        this.$router.push({
          name: 'CardSpecOpusV3',
          query
        })
      }
    }
  },
  computed: {
    nativeData: function () {
      const getData = {}
      // ネイティブから取得したデータを格納する。
      getData.tsid = this.$route.query.tsid
      getData.otoken = this.$route.query.otoken
      getData.appVersion = this.$route.query.x_cls_app_version
      getData.platform = this.$route.query.x_cls_os
      getData.osVersion = this.$route.query.x_cls_os_version
      return getData
    }
  },
  async mounted () {
    // 戻るボタン
    this.appDisplayBack(true)
    // タイトル
    this.appDisplayTitle('コスモ・ザ・カード')

    // TODO: アプリリニューアルのイベトラは Ph.2 で対応する
    // [eventTrack] カードスペック選択画面表示完了
    // this.nativePVset('CARD_NYUKAI_SOKUSHIN_SENTAKU')

    this.loading = false
  }
}

</script>
